export const PRODUCT_PRICE_KEYS = [
  'priceSell',
  'priceSell2',
  'priceSell3',
  'priceSell4',
  'priceSell5',
  'priceSell6',
  'priceSell7',
  'priceSell8',
];

export const buildPriceListOptions = (priceNames = []) => PRODUCT_PRICE_KEYS.map((_key, index) => ({
  text: String(priceNames[index] || '').trim() || `Precio ${index + 1}`,
  value: index,
}));

export const PRICE_LIST_OPTIONS = buildPriceListOptions();

export const normalizePriceListIndex = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 0 && parsed < PRODUCT_PRICE_KEYS.length
    ? parsed
    : 0;
};

/**
 * Obtiene un precio de lista sin tratar 0.00 como valor ausente.
 * fallback conserva precios de tickets históricos que no incluyen las listas.
 */
export const resolveProductPrice = (product, priceListIndex, fallback = 0) => {
  const key = PRODUCT_PRICE_KEYS[normalizePriceListIndex(priceListIndex)];
  const raw = product && product[key];
  if (raw === null || raw === undefined || raw === '') return Number(fallback) || 0;
  const price = Number(raw);
  return Number.isFinite(price) ? price : (Number(fallback) || 0);
};

export const copyProductPrices = (product = {}) => PRODUCT_PRICE_KEYS.reduce(
  (prices, key) => {
    if (product[key] !== undefined && product[key] !== null && product[key] !== '') {
      prices[key] = Number(product[key]);
    }
    return prices;
  },
  {},
);
